<template>
    <ul class="nav_breadcrumbs">
        <li>
            <router-link to="/modules/home">{{lang.LBL_HOME}}</router-link>
        </li>
        <li>
            <router-link to="/modules/applications">{{lang.LBL_VIEW_APPLLICATION}}</router-link>
        </li>
         <li>
            <!--<router-link to="#" data-bs-toggle="modal" data-bs-target="#emailsModal">{{lang.LBL_APP_EMAIL}}</router-link>!-->
           <!-- <template v-if="this.$route.params.id">
            <router-link :to="'/modules/applicationemails/unread/'+this.$route.params.id" target="_blank">{{lang.LBL_APP_EMAIL}}</router-link>
            </template>!-->
        </li>
    </ul>
</template>
<script>
    import lang from "@/views/modules/Applications/language/en";
    export default {
        name: "breadcrumbs",
        data() {
            return {
                lang: [],
            }
        },
        mounted() {
            this.lang = lang;
        },

    }
</script>